import {CanMatchFn} from '@angular/router';
import {inject} from '@angular/core';
import {KeycloakService} from './keycloak.service';

/**
 * Redirect unauthenticated users directly to Keycloak login (PKCE flow).
 * Returns false so Angular router stops navigation until KC redirects back.
 */
export const IsAuthenticated: CanMatchFn = (): boolean => {
    const kc = inject(KeycloakService);

    if (!kc.isLoggedIn) {
        kc.login(window.location.href);
        return false;
    }

    return true;
};
